import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import StageHeader from '../../components/stageHeader';
import UinsDefaultSelect from '../../components/unisDefaultSelect';
import template from './resources.vue';
import MainButtonSet from '../../components/mainButtonSet';
import UnisProductModal from '../../components/unisProductModal';
import Pagination from '../../components/pagination';
import Pager from '../../components/pager';
import { Select } from 'element-ui';
import { Option } from 'element-ui';

Vue.use(Select);
Vue.use(Option);
@Component({
    mixins: [template],
    components: {
        StageHeader,
        MainButtonSet,
        UinsDefaultSelect,
        UnisProductModal,
        Pagination,
        Pager,
    },
})
export default class Resources extends Vue {
    truckloadForm: any = {};
    editProductModal: string = 'addNewPaymentMethod';
    searchParams: any = {
        type: 'All',
        name: '',
    };
    paging: any = {
        pageSize: 10,
        currentPage: 1,
        totalSize: 0,
        text: 'quotes',
    };

    statusArr: any = [
        { value: 'All', label: 'All' },
        { value: 'Document', label: 'Document' },
        { value: 'Form', label: 'Form' },
    ];

    fileList: any = [
        {
            name: 'UNIS Rules Tariff UTPA 110-A',
            type: 'Document',
            extension: 'PDF',
            url:
                'https://cdn.prod.website-files.com/64b83df5325c7e3eef948c48/6633ba340ab9fc0100694bfd_UNIS_Rules_Tariff_UTPA_110-A_05%2024.pdf',
            show: true,
        },
        {
            name: 'UNIS Rules Tariff UTPA 110-A (Table)',
            type: 'Document',
            extension: 'PDF',
            url:
                'https://cdn.prod.website-files.com/64b83df5325c7e3eef948c48/654158094eaf0e4f51708884_UNIS_Rules_Tariff_2023.pdf',
            show: true,
        },
        {
            name: 'UNIS Fuel Index (2022)',
            type: 'Document',
            extension: 'PDF',
            url:
                'https://cdn.prod.website-files.com/64b83df5325c7e3eef948c48/6542bdd446eb258ea4979849_UNIS%2BFSC%2B11.01.23.pdf',
            show: true,
        },
        {
            name: 'UNIS High Cost Surcharge Zip List (2024)',
            type: 'Document',
            extension: 'XLSX',
            url:
                'https://cdn.prod.website-files.com/64b83df5325c7e3eef948c48/662fc92990b6790c7dddd28d_UNIS%20High%20Cost%20List.xlsx',
            show: true,
        },
        {
            name: 'UNIS Bill of Lading (F)',
            type: 'Form',
            extension: 'PDF',
            url:
                'https://cdn.prod.website-files.com/64b83df5325c7e3eef948c48/6542bdc51175a12d16097e17_UNIS_BOL_Form_V6.pdf',
            show: true,
        },
        {
            name: 'UNIS Bill of Lading (B)',
            type: 'Form',
            extension: 'PDF',
            url:
                'https://cdn.prod.website-files.com/64b83df5325c7e3eef948c48/654157141febfb1fd2af6d3b_UNIS_BOL_Form_B_2023.pdf',
            show: true,
        },
        {
            name: 'Freight Quote Form',
            type: 'Form',
            extension: 'PDF',
            url:
                'https://cdn.prod.website-files.com/64b83df5325c7e3eef948c48/654157b7913cea02e6ff2bcf_Freight%2BQuote_Form.pdf',
            show: true,
        },
        {
            name: 'Blind Shipment Agreement',
            type: 'Form',
            extension: 'PDF',
            url:
                'https://cdn.prod.website-files.com/64b83df5325c7e3eef948c48/65415780e06d4bbb3a5b5365_Blind%2BShipment%2BAgreement_Form.pdf',
            show: true,
        },
        {
            name: 'Additional Charge & Charge Authorization',
            type: 'Form',
            extension: 'PDF',
            url:
                'https://cdn.prod.website-files.com/64b83df5325c7e3eef948c48/6541578c8e6e125575388134_Additional%2BCharge%2Band%2Bauthorization%2Bfor%2Bcharges_02.pdf',
            show: true,
        },
        {
            name: 'Credit Card Authorization',
            type: 'Form',
            extension: 'PDF',
            url:
                'https://cdn.prod.website-files.com/64b83df5325c7e3eef948c48/65415795f79cc4afee965520_Credit_Card_Authorization.pdf',
            show: true,
        },
        {
            name: 'W-9 UNIS Transportation (2021)',
            type: 'Form',
            extension: 'PDF',
            url:
                'https://cdn.prod.website-files.com/64b83df5325c7e3eef948c48/654157c5b845173681f1270e_W-9%2BUnis%2BTransportation%2B2021.pdf',
            show: true,
        },
        {
            name: 'Credit Application',
            type: 'Form',
            extension: 'PDF',
            url:
                'https://cdn.prod.website-files.com/64b83df5325c7e3eef948c48/6542bd8998569814204838ca_UNIS%20Commercial%20Credit%20Application_V5.pdf',
            show: true,
        },
        {
            name: 'Letter of Authority',
            type: 'Form',
            extension: 'PDF',
            url:
                'https://cdn.prod.website-files.com/64b83df5325c7e3eef948c48/654157a2ea92d7c1e34a7dfc_Letter_of_Authority2023.pdf',
            show: true,
        },
        {
            name: 'Overcharge Claims Form',
            type: 'Form',
            extension: 'PDF',
            url:
                'https://cdn.prod.website-files.com/64b83df5325c7e3eef948c48/654157ae75694ee744c8868c_Overcharge%2BStandard%2BClaim_Form.pdf',
            show: true,
        },
    ];
    loading: Boolean = false;
    onItemSelect(id: any) {
        window.open(id);
    }
    selectStatus() {
        this.search();
    }
    search() {
        this.fileList.forEach((item: any) => {
            const shouldShow =
                this.searchParams.type === 'All' || this.searchParams.type === item.type;

            item.show =
                shouldShow &&
                (this.searchParams.name
                    ? item.name.toLowerCase().includes(this.searchParams.name.toLowerCase())
                    : true);
        });
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./src/layouts/resources/index.ts